import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="/submit-sr"
    image="/static/img/Card-ServiceRequest.png"
    imageAlt="A request of service from a professional"
    description="Submit a Service Request"
    loggedOutDescription="Log in to Submit a Service Request"
  >
    Request a service offered by Skyward
  </FeatureCard>
);
